import { ajax } from "@/assets/js/ajax";
export function getAudit(data) {     //审核列表
  return ajax({
    url: 'audit/lists',
    type: 'get',
    data: data
  })
}

export function auditCheck(data) {     //审核
  return ajax({
    url: 'audit/check',
    type: 'post',
    data: data
  })
}
